import {useParams} from 'react-router-dom';
import {Alert} from '@mantine/core';

import {
    FormPageLayout,
    PlatformEditPageGrid,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {DetailPageNavigation} from '../navigation/DetailPageNavigation.tsx';
import {ObservationsPanel} from '../components/ObservationsPanel.tsx';
import {useSyntheticUser} from '../hooks/useSyntheticUser.ts';

// FNP-861: READ-ONLY detail view. No edit mode, no wake trigger, no retire action.
export const DetailPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record,
        loading,
        isError,
        notFound,
    } = useSyntheticUser(id);

    if (loading) {
        return <PlatformLoader message='Loading synthetic user...Please wait'/>;
    }

    if (isError || notFound || !record) {
        return (
            <Alert color='red' title='Synthetic user not found'>
                No synthetic user found for id <code>{id}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={record.email}
            pageNavigation={<DetailPageNavigation component={record}/>}
        >
            {/* Right side is what this user actually did — the GSI-backed link
                between the roster and the observations (FNP-861). The summary
                sits left, where the grid can collapse it to widen that list. */}
            <PlatformEditPageGrid
                leftContent={<Profile record={record}/>}
                rightContent={<ObservationsPanel syntheticUserId={record.id}/>}
            />
        </FormPageLayout>
    );
};
